import { defineStore } from 'pinia';

const useAnalyticsStore = defineStore('analytics', {
  state: () => ({
    userId: null,
    utm: {},
  }),

  actions: {
    extractUtmFromObject(obj = {}) {
      const utm = {};
      [
        'utm',
        'utm_source',
        'utm_medium',
        'utm_campaign',
        'utm_term',
        'utm_content',
      ].forEach((key) => {
        if (obj[key]) utm[key] = obj[key];
      });
      return utm;
    },

    updateUtm(newUtm = {}) {
      const extracted = this.extractUtmFromObject(newUtm);
      this.utm = extracted;
    },

    setUserId(uuid) {
      this.userId = uuid;
      window.gtag && window.gtag('set', { user_id: uuid });
    },

    track(eventName, payload = {}) {
      const mergedPayload = { ...payload, ...this.utm };
      window.gtag && window.gtag('event', eventName, mergedPayload);
    },

    trackFbq(eventName, payload = {}) {
      if (window.fbq && process.env.NODE_ENV === 'production') {
        window.fbq('track', eventName, payload);
      }
    },
  },
});

export default useAnalyticsStore;
